<template>
	<div v-loading="loading" element-loading-text="获取数据中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row :gutter="20">
			<el-col>
				<el-card>
					<el-form inline size="small">
						<el-form-item>
							<el-select v-model="area" placeholder="省份">
								<el-option v-for="item in provinceOptions" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-input v-model="keywords" placeholder="经销商名称/授权模式/区域/" clearable maxlength="30">
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" plain @click="search()">搜索</el-button>
							<el-button type="info" plain @click="resetSearch()">重置</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-button type="success" @click="addData()">新增经销商</el-button>
							<el-button type="primary"  @click="exportData()">导出</el-button>
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
		</el-row>

		<el-row style="margin-top:15px;">
			<el-card>
				<el-table :data="tableData" style="width: 100%; " stripe>
					<el-table-column label="公司名称" prop="dist_name" sortable width="240" />
					<el-table-column label="所负责区域" prop="dist_area" sortable width="240" />
					<el-table-column label="负责人" prop="dist_contact" sortable width="100"></el-table-column>
					<el-table-column label="授权模式" prop="dist_authorize_brand" sortable width="180"></el-table-column>
					<el-table-column label="级别" prop="dist_level" sortable width="100"></el-table-column>
					<el-table-column label="邮寄地址" prop="dist_address"></el-table-column>
					<el-table-column label="备注" prop="dist_remark" width="80"></el-table-column>
					<el-table-column label="更新时间" prop="update_date" sortable width="100">
						<template slot-scope="props">
							<span>
								{{
									props.row.update_date
										.split('T')
										.slice(0, 1)
										.join('')
								}}
							</span>
						</template>
					</el-table-column>
					<el-table-column width="150" label="操作" align="center">
						<template slot-scope="scope">
							<el-button-group>
								<el-button size="mini" icon="el-icon-edit"
									@click="updateData(scope.$index, scope.row)">改</el-button>
								<el-button type="danger" size="mini" icon="el-icon-delete"
									@click="deleteData(scope.$index, scope.row)">删</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
		</el-row>

		<!-- 分页 -->
		<el-row class="paginator hidden-sm-and-down">
			<el-pagination background :current-page.sync="currentPage" layout="total, sizes, prev, pager, next"
				:total="totalItems" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" />
		</el-row>

		<el-row class="paginator hidden-sm-and-up">
			<el-pagination background :current-page.sync="currentPage" layout="prev, pager, next" :total="totalItems"
				:page-size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"
				prev-text="上一页" next-text="下一页" :pager-count="5" />
		</el-row>

		<!-- 新增数据表单 -->
		<el-dialog title="新增经销商" :visible.sync="formAddDialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" :width="'60%'" :fullscreen="ifFullScreen">
			<el-form ref="formAddData" :rules="rules" :model="formAddData" :label-width="formLabelWidth" size="mini">
				<el-form-item label="公司名称" prop="dist_name"><el-input v-model="formAddData.dist_name" /></el-form-item>
				<el-form-item label="所负责区域" prop="dist_area">
					<el-select v-model="formAddData.dist_area" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in provinceOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="负责人" prop="dist_contact"><el-input type="textarea" autosize
						v-model="formAddData.dist_contact" /></el-form-item>
				<el-form-item label="授权模式" prop="dist_authorize_brand"><el-input type="textarea" autosize
						v-model="formAddData.dist_authorize_brand" /></el-form-item>
				<el-form-item label="经销商级别" prop="dist_level">
					<el-select v-model="formAddData.dist_level" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in levelOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="邮寄地址" prop="dist_address"><el-input type="textarea" autosize
						v-model="formAddData.dist_address" /></el-form-item>
				<el-form-item label="备注" prop="dist_remark"><el-input type="textarea" autosize
						v-model="formAddData.dist_remark" /></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('formAddData')">取 消</el-button>
				<el-button type="danger" @click="submitAddForm('formAddData')">提 交</el-button>
			</div>
		</el-dialog>

		<!-- 更新数据表单 -->
		<el-dialog title="修改经销商信息" :visible.sync="formUpdateDialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" :fullscreen="ifFullScreen">
			<el-form ref="formUpdateData" :rules="rules" :model="formUpdateData" :label-width="formLabelWidth"
				size="mini">
				<el-form-item label="公司名称" prop="dist_name"><el-input
						v-model="formUpdateData.dist_name" /></el-form-item>
				<el-form-item label="所负责区域" prop="dist_area">
					<el-select v-model="formUpdateData.dist_area" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in provinceOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="负责人" prop="dist_contact"><el-input type="textarea" autosize
						v-model="formUpdateData.dist_contact" /></el-form-item>
				<el-form-item label="授权模式" prop="dist_authorize_brand"><el-input type="textarea" autosize
						v-model="formUpdateData.dist_authorize_brand" /></el-form-item>
				<el-form-item label="经销商级别" prop="dist_level">
					<el-select v-model="formUpdateData.dist_level" filterable placeholder="请选择" allow-create
						default-first-option>
						<el-option v-for="item in levelOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="邮寄地址" prop="dist_address"><el-input type="textarea" autosize
						v-model="formUpdateData.dist_address" /></el-form-item>
				<el-form-item label="备注" prop="dist_remark"><el-input type="textarea" autosize
						v-model="formUpdateData.dist_remark" /></el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="formUpdateDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitUpdateForm('formUpdateData')">提 交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		inject: ['reload', 'logout'],
		data() {
			return {
				tableData: [],
				keywords: '',
				// ifMyOwn: true,
				formAddDialogVisible: false,
				formUpdateDialogVisible: false,
				ifFullScreen: false,
				area: '',
				level: '',
				dialogHistoryVisible: false,
				formAddData: {
					pk: '',
					dist_name: '',
					dist_area: '',
					dist_level: '',
					dist_authorize_brand: '',
					dist_address: '',
					dist_contact: '',
					dist_remark: ''
				},
				formUpdateData: {
					pk: '',
					dist_name: '',
					dist_area: '',
					dist_level: '',
					dist_authorize_brand: '',
					dist_address: '',
					dist_contact: '',
					dist_remark: ''
				},
				//新增和更新表单的验证规则
				rules: {
					dist_name: [{
						required: true,
						message: '请填写经销商名称',
						trigger: 'blur'
					}, {
						max: 40,
						message: '长度不超过40个字符',
						trigger: 'blur'
					}],
					dist_area: [{
						required: true,
						message: '请选择或填写省份',
						trigger: 'change'
					}],
					dist_level: [{
						required: true,
						message: '请填写经销商级别',
						trigger: 'change'
					}]
				},
				formLabelWidth: '100px',
				totalItems: 100,
				currentPage: 1,
				pageSize: 20,
				deleteItemPk: '',
				loading: false,
				visible: false,
				provinceOptions: [{
						value: '北京',
						label: '北京'
					},
					{
						value: '天津',
						label: '天津'
					},
					{
						value: '上海',
						label: '上海'
					},
					{
						value: '重庆',
						label: '重庆'
					},
					{
						value: '河北',
						label: '河北'
					},
					{
						value: '山西',
						label: '山西'
					},
					{
						value: '辽宁',
						label: '辽宁'
					},
					{
						value: '吉林',
						label: '吉林'
					},
					{
						value: '黑龙江',
						label: '黑龙江'
					},
					{
						value: '江苏',
						label: '江苏'
					},
					{
						value: '浙江',
						label: '浙江'
					},
					{
						value: '安徽',
						label: '安徽'
					},
					{
						value: '福建',
						label: '福建'
					},
					{
						value: '江西',
						label: '江西'
					},
					{
						value: '山东',
						label: '山东'
					},
					{
						value: '河南',
						label: '河南'
					},
					{
						value: '湖北',
						label: '湖北'
					},
					{
						value: '湖南',
						label: '湖南'
					},
					{
						value: '广东',
						label: '广东'
					},
					{
						value: '甘肃',
						label: '甘肃'
					},
					{
						value: '四川',
						label: '四川'
					},
					{
						value: '贵州',
						label: '贵州'
					},
					{
						value: '海南',
						label: '海南'
					},
					{
						value: '云南',
						label: '云南'
					},
					{
						value: '青海',
						label: '青海'
					},
					{
						value: '陕西',
						label: '陕西'
					},
					{
						value: '广西',
						label: '广西'
					},
					{
						value: '西藏',
						label: '西藏'
					},
					{
						value: '宁夏',
						label: '宁夏'
					},
					{
						value: '新疆',
						label: '新疆'
					},
					{
						value: '内蒙',
						label: '内蒙'
					},
					{
						value: '澳门',
						label: '澳门'
					},
					{
						value: '香港',
						label: '香港'
					},
					{
						value: '台湾',
						label: '台湾'
					}
				],
				levelOptions: [{
						value: '省级代理',
						label: '省级代理'
					},
					{
						value: '地区代理',
						label: '地区代理'
					},
					{
						value: '二级代理',
						label: '二级代理'
					},
					{
						value: '其他',
						label: '其他'
					}
				]
			};
		},
		methods: {
			//通用函数-获取数据
			getData() {
				let that = this;
				that.loading = true;
				this.$axios
					.get('/apia/get/distributor/', {
						params: {
							keywords: that.keywords,
							currentpage: that.currentPage,
							pagesize: that.pageSize,
							level: that.level,
							area: that.area
						}
					})
					.then(function(response) {
						if (response.data.code == '401') {
							that.logout();
						} else {
							that.tableData = response.data.data;
							// console.log(response.data.data);
							that.totalItems = response.data.totalItemNum;
							that.loading = false;
						}
					})
					.catch(function(error) {
						console.log(error);
						that.loading = false;
					});
			},
			//导出数据
			exportData() {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fileName = '经销商名单' + Date.now();
				this.$axios({
						url: '/apia/export/distributor/',
						responseType: 'blob',
						method: 'get',
						data: {
							keywords: that.keywords,
							level: that.level,
							area: that.area
						},
					})
					.then(function(res) {
						const _res = res.data;
						let blob = new Blob([_res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
						});
						let objectUrl = window.URL.createObjectURL(blob);
						let a = document.createElement('a');
						a.href = objectUrl;
						a.download = fileName.replace('.', '');
						a.dispatchEvent(new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window
						}));
						that.loading = false;
						window.URL.revokeObjectURL(blob);
					})
					.catch(function(err) {
						that.loading = false;
						console.log(err);
					});

			},

			//通用功能 - 关键字搜索
			search() {
				this.currentPage = 1;
				this.getData();
			},
			// 重置搜索
			resetSearch() {
				this.currentPage = 1;
				this.keywords = "";
				this.area = "";
				this.getData();
			},
			//新增数据-对话框
			addData() {
				this.formAddDialogVisible = true;
			},
			//新增数据-提交
			submitAddForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let that = this;
						let fd = new FormData();
						let formData = this.formAddData;
						//添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						// console.log(this.formAddData);
						this.$axios({
								url: '/apia/add/distributor/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == 200) {
									that.reload();
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						return false;
					}
				});
			},
			//新增数据 - 重置表单
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.formAddDialogVisible = false;
			},
			//更新数据 - 对话框
			updateData(index, row) {
				//解除双向绑定
				this.formUpdateData = JSON.parse(JSON.stringify(row));
				this.formUpdateDialogVisible = true;
				// console.log(this.formUpdateData)
			},
			//更新数据-提交
			submitUpdateForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let that = this;
						let fd = new FormData();
						let formData = this.formUpdateData;
						//遍历添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						this.$axios({
								url: '/apia/update/distributor/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == 200) {
									that.getData();
									that.formUpdateDialogVisible = false;
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					} else {
						return false;
					}
				});
			},
			//删除数据 - 对话框
			deleteData(index, row) {
				let deleteItemPk = JSON.parse(JSON.stringify(row)).pk;
				this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.submitDeleteData(deleteItemPk);
					})
					.catch(() => {});
			},
			//删除数据-提交
			submitDeleteData(dataPk) {
				let that = this;
				let fd = new FormData();
				fd.append('pk', dataPk);
				this.$axios({
						url: '/apia/delete/distributor/',
						method: 'post',
						data: fd,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(res) {
						if (res.data.code == 200) {
							that.getData();
						} else {
							that.$message({
								message: res.data.message,
								type: 'warning'
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//分页跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData();
			},
			//每页显示条数更改
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getData();
			},
		},
		mounted() {
			this.getData();
			this.ifFullScreen = document.body.clientWidth > 720 ? false : true;
		}
	};
</script>

<style></style>